import React, { useEffect, useState, useCallback } from "react";
import createPersistedState from "use-persisted-state";
import { I18nContext, availableLangs, translations } from "./I18n";
// Import the locales correctly as named exports
import { enGB } from 'date-fns/locale/en-GB';
import { ja } from 'date-fns/locale/ja';

type lang = "gb" | "jp";

const STORAGE_KEY = "i18n";
const useLang = createPersistedState<lang>(STORAGE_KEY);

// Map of language codes to date-fns locale objects
const localeMap = {
  gb: enGB,
  jp: ja
};

function placeholderReplace(source, params) {
  params.forEach(function (n, i) {
    source = source.replace(new RegExp("\\{" + i + "\\}", "g"), n);
  });
  return source;
}

export default function I18nProvider({ children }) {
  const [lang, setLang] = useLang(availableLangs[0]);
  const [dateLocale, setDateLocale] = useState(
    localeMap[lang] || enGB
  );

  const t = useCallback(
    (key = "", ...params) => {
      const i18nValue =
        translations[lang][typeof key === "string" && key.toLowerCase()] ||
        translations[lang][key];
      
      if (!i18nValue && key.indexOf("/") === -1 && key.indexOf(":") === -1) {
        //check the '/' and ':' character for the dates and time 
        // console.warn(
        //   `i18n key: "${key}" doesn't exist. Please add it to /providers/I18n/translations/*.json`
        // );
        return key;
      }
      
      if (key.indexOf("/") !== -1 || key.indexOf(":") !== -1) {
        return key;
      }
      
      if (params.length > 0) {
        return placeholderReplace(i18nValue, params);
      }
      
      return i18nValue;
    },
    [lang]
  );

  const updateLocale = (lang) => {
    setLang(lang);
    setDateLocale(localeMap[lang] || enGB);
  };

  useEffect(() => {
    // setLang(lang);
    setDateLocale(localeMap[lang] || enGB);
  }, [lang, setLang]);

  return (
    <I18nContext.Provider
      value={{
        lang,
        t,
        updateLocale: updateLocale,
        availableLangs,
        dateLocale,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
}
